// JoditEditorComponent.jsx
import React, { useRef, useEffect } from "react";
import JoditEditor from "jodit-react";

const JoditEditorComponent = ({
  defaultValue = "",
  onChange,
  placeholder = "Enter text...",
  height = 300,
}) => {
  const editor = useRef(null);

  return (
    <JoditEditor
      ref={editor}
      value={defaultValue}
      config={{
        readonly: false,
        height,
        placeholder,
        toolbarSticky: false,
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        allowPasteImages: true,
        disablePlugins: ["pasteStorage"],
        style: {
          fontFamily: "Montserrat, sans-serif",
        },
        controls: {
          font: {
            list: {
              "Montserrat,sans-serif": "Montserrat",
              "Helvetica,sans-serif": "Helvetica",
              "Arial,Helvetica,sans-serif": "Arial",
              "Georgia,serif": "Georgia",
              "Impact,Charcoal,sans-serif": "Impact",
              "Tahoma,Geneva,sans-serif": "Tahoma",
              "Times New Roman,Times,serif": "Times New Roman",
              "Verdana,Geneva,sans-serif": "Verdana",
            },
          },
        },
      }}
      onBlur={(newContent) => {
        onChange(newContent);
      }}
    />
  );
};

export default JoditEditorComponent;
